<template>
    <div>
      <div class="flex justify-between items-center mb-6">
        <h1 class="text-2xl font-bold">Opportunities</h1>
        <router-link to="/admin/opportunities/create">
          <primary-button>Create New</primary-button>
        </router-link>
      </div>
  
      <!-- Sort Controls -->
      <div class="flex flex-wrap items-center gap-4 mb-6">
        <label class="text-sm">
          Sort by:
          <select v-model="sortBy" class="ml-2 p-2 bg-gray-800 text-white rounded-xl">
            <option value="title">Title</option>
            <option value="organization">Organization</option>
            <option value="deadline">Deadline</option>
          </select>
        </label>
      </div>
  
      <!-- Opportunities Table -->
      <div class="overflow-x-auto rounded-xl bg-gray-900 border border-gray-800">
        <table class="min-w-full text-left">
          <thead class="bg-gray-800 text-gray-300 text-sm">
            <tr>
              <th class="p-4">Title</th>
              <th class="p-4">Organization</th>
              <th class="p-4">Deadline</th>
              <th class="p-4">Actions</th>
            </tr>
          </thead>
          <tbody v-show="sortedOpportunities">
            <tr v-for="opp in sortedOpportunities" :key="opp.id" class="border-t border-gray-800 hover:bg-gray-800">
              <td class="p-4">{{ opp.title }}</td>
              <td class="p-4">{{ opp.organization }}</td>
              <td class="p-4">{{ formatDate(opp.deadline) }}</td>
              <td class="p-4 flex gap-2">
                <router-link :to="`/admin/opportunities/${opp.id}/edit`">
                  <secondary-button class="md:text-base text-sm">Edit</secondary-button>
                </router-link>
                <button @click="deleteOpportunity(opp.id)">
                  <primary-button class="bg-red-600 hover:bg-red-500 md:text-base text-sm">Delete</primary-button>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, computed } from 'vue'
  import { useRouter } from 'vue-router'
  import { destroyOpportunity } from '@/utils/opportunity'
  import PrimaryButton from '../../components/button/PrimaryButton.vue'
  import SecondaryButton from '../../components/button/SecondaryButton.vue'
  import api from '@/utils/api'

  const router = useRouter()
  // const opportunities = ref([
  //   {
  //     id: 1,
  //     title: 'Incubate Nepal',
  //     organization: 'Incubate Nepal',
  //     deadline: '2025-06-15'
  //   },
  //   {
  //     id: 2,
  //     title: 'Youth Leadership Bootcamp 2025',
  //     organization: 'LEAD Nepal',
  //     deadline: '2025-05-10'
  //   },
  //   {
  //     id: 3,
  //     title: 'STEM Research Program',
  //     organization: 'Nepal Science Foundation',
  //     deadline: '2025-07-01'
  //   }
  // ])
  const opportunities = ref([])

  const sortBy = ref('title')
  
  const sortedOpportunities = computed(() => {
    return [...opportunities.value].sort((a, b) => {
      const field = sortBy.value
      const aValue = a[field]
      const bValue = b[field]

      // Handle date sorting (e.g., 'deadline', 'created_at')
      if (field === 'deadline' || field === 'created_at') {
        return new Date(aValue) - new Date(bValue)
      }

      // Handle string comparison safely
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return aValue.localeCompare(bValue)
      }

      // Fallback for number or undefined values
      return (aValue || 0) - (bValue || 0)
    })
  })

  
  const deleteOpportunity = async (id) => {
    if (confirm('Are you sure you want to delete this opportunity?')) {
      const destroy = await destroyOpportunity(id)
      if (destroy)
      {
        alert('Opportunity deleted successfully!')
        return true
      }
      alert('Something went wrong!')
      return false
    }
  }
  
  const formatDate = (dateStr) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' }
    return new Date(dateStr).toLocaleDateString(undefined, options)
  }

  onMounted(async() => {
    try {
        const response = await api.get('opportunities/index')
        if (response.data.status == 'error')
        {
            router.push({
                path: '/'
            })
        }
        if (response.status == 200)
        {
          opportunities.value = response.data.data.data
        }
    } catch (error) {
        console.error('API error:', error)
    }

    document.title = 'Dashboard'
  })
  </script>
  
  <style scoped>
  /* optional smoother table hover */
  table tr:hover {
    transition: background 0.2s;
  }
  </style>
  